<template>
  <div class="activityProject">
    <div v-for="(activity, activityIndex) in actList" :key="activity.actNumber" v-if="!(source == 3 && activity.recipeSourceType == '0')" :class="{ 'activity': true, 'disabled': isDisabled }">
      <div class="header">
        <div class="header_left">
          <img class="header_left_icon" :src="imgArr.present" />
          <div class="header_left_title">{{ activity.actCseName }}</div>
          <div class="header_left_description">共{{ activity.actCount }}套，总价￥{{ activity.totalPrice }}</div>
        </div>
        <div class="header_right" v-if="!isDisabled">
          <div class="header_edit" @click="editActivity(activityIndex)">修改</div>
          <div class="el-icon-delete header_delete" @click="removeActivity(activityIndex)"></div>
        </div>
      </div>
      <div classs="project_list">
        <template v-for="(project, projectIndex) in activity.items">
          <!-- 理疗 -->
          <div v-if="project.drugType === 1" :key="project.spuId" class="project_item">
            <div class="project_header">
              <div class="project_header_index">{{ projectIndex + 1 }}</div>
              <div class="project_header_label">
                <div class="project_header_label_name">{{ project.spuCommonName }}</div>
                <div class="project_header_label_type">理疗</div>
              </div>
            </div>
            <!-- 穴位、部位 -->
            <div v-if="project.physioExtendJson" class="project_point_section">

              <div class="acupoint-list">
                <div class="acupoint-item"
                  v-for="(acupoint, acupointIndex) in (project.physioExtendJson && project.physioExtendJson.acupointinfoList || [])"
                  :key="acupoint.acupointId">
                  <div
                    v-if="alreadyAdd == `note${activityIndex}${projectIndex}${acupointIndex}`"
                    class="acupoint-item-tips">
                    已添加过该{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}
                  </div>
                  <div
                    v-if="speciesTypeTips == `note${activityIndex}${projectIndex}${acupointIndex}`"
                    class="acupoint-item-tips">
                    选择{{ acupoint.speciesType == 10 ? '穴位' : '部位' }}不计入{{ acupoint.speciesType == 10 ? '部位' : '穴位' }}数
                  </div>
                  <div class="acupoint-item-tips2 w60" v-if="isDisabled && acupoint.type == 50">数量{{  acupoint.typeExtend[0]  }}</div>
                  <div class="acupoint-item-tips2 w230" v-if="isDisabled && acupoint.type == 60">
                    <div v-if="computedShowAcupointTips(SiFenLeft, acupoint).flag">左手：{{computedShowAcupointTips(SiFenLeft, acupoint).str}}</div>
                    <div class="mt4" v-if="computedShowAcupointTips(SiFenRight, acupoint).flag">右手：{{computedShowAcupointTips(SiFenRight, acupoint).str}}</div>
                  </div>
                  <el-popover
                    :ref="'popover' + activityIndex + projectIndex + acupointIndex"
                    placement="bottom"
                    trigger="click"
                    popper-class="acupoint-popover"
                    :disabled="isDisabled || acupoint.type == 10">
                    <!-- 普通穴位 -->
                    <div class="acupoint-position" v-if="acupoint.type != 50 && acupoint.type != 60">
                      <div
                        :class="{
                          'acupoint-position-item': true,
                          'acupoint-position-item-active': acupoint.type == type.value ? true : false,
                          'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10
                        }"
                        v-for="type in acupointType" :key="type.value"
                        @click="changeAcupointType(type.value, activityIndex, projectIndex, acupointIndex)">
                        {{ type.label }}
                      </div>
                    </div>
                    <!-- 阿是穴 -->
                    <div class="acupoint-position" v-if="acupoint.type == 50">
                      <div
                        :class="{
                          'acupoint-position-item': true,
                          'acupoint-position-item-active': type == computedAcupointType(acupoint.type,acupoint.typeExtend) ? true : false,
                          'acupoint-position-item-disabled': acupoint.type != 10 && type.value == 10
                        }"
                        v-for="type in AshiPoints" :key="type"
                        @click="changeAcupointType(type, activityIndex, projectIndex, acupointIndex)">
                        {{ type }}
                      </div>
                    </div>
                    <!-- 四缝穴 -->
                    <div class="acupoint-SiFen" v-if="acupoint.type == 60">
                      <div>左手：</div>
                      <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1" @change="SiFenChange($event, activityIndex)">
                        <el-checkbox v-for="item in SiFenLeft" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                      </el-checkbox-group>
                      <div class="mt12">右手：</div>
                      <el-checkbox-group v-model="acupoint.typeExtend" class="mt6" :min="1" @change="SiFenChange($event, activityIndex)">
                        <el-checkbox v-for="item in SiFenRight" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <el-button slot="reference" :class="isDisabled ? 'disabled acupoint-item-left' :'acupoint-item-left' ">
                      {{ computedAcupointType(acupoint.type, acupoint.typeExtend) }}
                    </el-button>
                  </el-popover>
                  <el-select
                    v-model="acupoint.acupointName"
                    :disabled="isDisabled"
                    :default-first-option="true"
                    :placeholder="project.physioExtendJson && project.physioExtendJson.perUnit | filterPerUnit"
                    filterable
                    popper-class="customSelectStyle"
                    remote
                    reserve-keyword
                    @focus="acupointFocus(acupoint)"
                    :remote-method="query => getAcupointsList(query)"
                    @change="changeAcupoint($event, activityIndex, projectIndex, acupointIndex)">
                    <el-option
                      v-for="item in acupointOptions"
                      :key="item.acupointId"
                      :label="item.acupointName"
                      :value="item.acupointId">
                    </el-option>
                  </el-select>
                  <i class="el-icon-close" v-if="!isDisabled" @click="deleteAcupoint(activityIndex, projectIndex, acupointIndex)"></i>
                </div>
                <div class="acupoint-item" v-if="!isDisabled">
                  <div
                    class="acupoint-item-tips"
                    v-if="alreadyAdd == `note${activityIndex}${projectIndex}`">
                    已添加过该{{ project.physioExtendJson && project.physioExtendJson.perUnit | filterPerUnit }}
                  </div>
                  <el-select
                    v-model="acupointName"
                    :default-first-option="true"
                    :ref="'search' + activityIndex + projectIndex"
                    :placeholder="project.physioExtendJson && project.physioExtendJson.perUnit | filterPerUnit"
                    filterable
                    popper-class="customSelectStyle"
                    remote
                    reserve-keyword
                    :remote-method="query => getAcupointsList(query)"
                    @change="selectAcupointName($event, activityIndex, projectIndex)">
                    <el-option
                      v-for="item in acupointOptions"
                      :key="item.acupointId"
                      :label="item.acupointName"
                      :value="item.acupointId">
                    </el-option>
                  </el-select>
                  <div class="acupoint-item-icon" @click="openAcupoint(activityIndex, projectIndex)">
                    <img :src="imgArr.acupointIcon" class="acupoint-icon" alt="">
                  </div>
                </div>
              </div>
              <div
                class="acupoint-total"
                :class="{'color667': computedPerUnitCount(project.physioExtendJson) < computeMultiplication(project.physioExtendJson.perUnitCount, project.physioExtendJson.onlyNum)}"
                v-if="project.physioExtendJson && project.physioExtendJson.executionMode && project.physioExtendJson.perUnitCount">
                {{project.physioExtendJson && project.physioExtendJson.perUnit | filterPerUnitShow}}
                ：
                {{ computedPerUnitCount(project.physioExtendJson) }} / {{ computeMultiplication(project.physioExtendJson.perUnitCount, project.physioExtendJson.onlyNum) }}
              </div>
              <div class="acupoint-total" v-else>
                {{ project.physioExtendJson && project.physioExtendJson.perUnit | filterPerUnitShow}}
                ：
                {{ computedPerUnitCount(project.physioExtendJson) }}
              </div>

            </div>
            <!-- 频率 -->
            <div v-if="project.physioExtendJson" class="project_options">
              <div class="project_options_item">{{ project.itemNum }}次</div>
              <div v-if="project.physioExtendJson.executionMode == 20" class="project_options_item">1次{{ project.physioExtendJson.onlyNum }}组</div>
              <div class="project_options_select">
                <SelectPanel
                  v-model="project.executeDesc"
                  :width="'70px'"
                  :columnsNum="3"
                  :options="physioIntervalEnum"
                  :readonly="true"
                  placeholder="频率"
                  :disabled="isDisabled"
                  @input="physioIntervalEnumChange($event, activityIndex, projectIndex)">
                </SelectPanel>
              </div>
              <div v-if="project.physioExtendJson && project.physioExtendJson.perUnitCount" class="project_options_tips">
                <template v-if="project.physioExtendJson.executionMode == 10">每次至少选择{{ project.physioExtendJson.perUnitCount }}个{{ project.physioExtendJson.perUnit === 10 ? '穴位' : '部位' }}</template>
                <template v-if="project.physioExtendJson.executionMode == 20">每组{{ project.physioExtendJson.perUnitCount }}个{{ project.physioExtendJson.perUnit === 10 ? '穴位' : '部位' }}，每次至少选择{{ project.physioExtendJson.perUnitCount * project.physioExtendJson.onlyNum }}个{{ project.physioExtendJson.perUnit === 10 ? '穴位' : '部位' }}</template>
              </div>
            </div>
            <div class="project_remark">
              <el-input
                class="physio_product_remark"
                type="textarea"
                v-model="project.remark"
                placeholder="理疗备注"
                :autosize="{ minRows: 1, maxRows: 3 }"
                resize="none"
                :disabled="isDisabled"
                clearable
                maxlength="100"
                show-word-limit
                @input="physioRemarkInput(project)"
                @blur="physioRemarkBlur(project);saveActivity(activityIndex)">
              </el-input>
            </div>
          </div>
          <!-- 普通商品 -->
          <div v-if="[2, null, undefined, ''].includes(project.drugType)" :key="project.spuId" class="project_item">
            <div class="project_header">
              <div class="project_header_index">{{ projectIndex + 1 }}</div>
              <div class="project_header_label">
                <el-tooltip
                  v-if="project.inventory != undefined && ((project.itemNum > project.inventory && project.onSale == '1') || !project.inventory)"
                  class="item"
                  effect="dark"
                  content="库存不足"
                  placement="top">
                  <span class="iconfont icon-jingg colorFE8F mr8"></span>
                </el-tooltip>
                <el-tooltip
                  v-if="project.onSale == '0'"
                  class="item"
                  effect="dark"
                  content="本店暂无该药品"
                  placement="top">
                  <span class="iconfont icon-tinshou colorF54A mr8"></span>
                </el-tooltip>
                <div class="project_header_label_name">{{ project.itemName }}</div>
                <div class="project_header_label_type">普通商品</div>
              </div>
              <div class="project_header_count">{{ project.itemNum }}{{ project.itemUnit }}</div>
              <div class="project_header_remark">
                <el-input
                  class="project_header_remark_input"
                  v-model="project.remark"
                  :disabled="isDisabled"
                  placeholder="备注"
                  type="text"
                  style="width: 100%;"
                  @blur="saveActivity(activityIndex)">
                </el-input>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <acupoint-dialog
      v-if="acupointDialogShow"
      :dialogVisible="acupointDialogShow"
      @close="acupointDialogClose"
      @accupointConfirm="accupointConfirm"
      :acupointDialogObj="acupointDialogObj"
      :tabIndex = acupointDialogObj.tabIndex
      :chooseList="chooseList">
    </acupoint-dialog>
    <ComboEdit ref="comboEdit" @submit="submitComboEdit"></ComboEdit>
  </div>
</template>

<script>
  import { imgArr } from '@/assets/images/img'
  import { deepClone, isNull, msgboxWarning, isEmptyArray, dictText,debounce } from '@/utils/validateBase'

  import ComboEdit from '@/components/campaign/comboEdit.vue'
  import SelectPanel from '@/components/SelectPanel.vue'
  import acupointDialog from "../component/acupointDialog.vue";

  import { getPhysioIntervalEnum } from "@/api/physio"
  import { acupointList } from "@/api/acupoint"
  import { postCombSaleSelect, deleteCombSaleSelect } from "@/api/campaign"

  export default {
    components: {
      ComboEdit,
      SelectPanel,
      acupointDialog
    },
    props: {
      // 来源类型：1-门诊, 2-收费, 3-补录处方
      source: {
        type: [String, Number],
        default: 1
      },
      deptId: {
        type: [String, Number],
        default: ''
      },
      orderId: {
        type: [String, Number],
        default: ''
      },
      actList: {
        type: Array,
        default: () => []
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        imgArr: imgArr,
        acupointOptions: [],
        physioIntervalEnum: [],
        alreadyAdd: '',
        speciesTypeTips: '',
        focusAcupoint: {},
        chooseList: [],
        AshiPoints:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
        acupointName: '',
        acupointType: [
          { label: '单', value: 10 },
          { label: '双', value: 20 },
          { label: '左', value: 30 },
          { label: '右', value: 40 },
        ],
        SiFenLeft:[
          { label: '四缝1', value: '1-1' },
          { label: '四缝2', value: '1-2' },
          { label: '四缝3', value: '1-3' },
          { label: '四缝4', value: '1-4' },
        ],
        SiFenRight:[
          { label: '四缝1', value: '2-1' },
          { label: '四缝2', value: '2-2' },
          { label: '四缝3', value: '2-3' },
          { label: '四缝4', value: '2-4' },
        ],
        acupointDialogShow: false,
        acupointDialogObj: {},
      }
    },
    filters: {
      filterPerUnit(val) {
        return isNull(val) ? '穴位/部位' : (val == 10 ? '穴位' : '部位')
      },
      filterPerUnitShow(val) {
        return isNull(val) ? '已选' : (val == 10 ? '穴位' : '部位')
      }
    },
    computed: {
      computedShowAcupointTips(){
        return function(list, acupoint){
          let str = ''
          let flag = false
          acupoint.typeExtend.forEach(v1=>{
            list.forEach(v2=>{
              if(v1 == v2.value){
                flag = true
                str = str + v2.label + '、'
              }
            })
          })
          return {str: str.slice(0, -1), flag }
        }
      },
      computedAcupointType() {
        let that = this;
        return function (type,typeExtend) {
          if(type == 50){
            return typeExtend[0]
          }else if( type == 60){
            return isNull(typeExtend) ? 0 : typeExtend.length
          }else{
            return dictText(type, that.acupointType)
          }
        }
      },
      computedPerUnitCount() {
        return function (physioExtendJson) {
          let num = 0
          let acupointinfoList = physioExtendJson.acupointinfoList || []
          let perUnit = physioExtendJson.perUnit
          if (isNull(perUnit)) {
            acupointinfoList.forEach(v => {
              if(v.type == 60){
                num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
              }else if(v.type == 50){
                num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
              }else if(v.type == 20){
                num = num + 2;
              }else{
                num = num + 1
              }
            })
          } else {
            acupointinfoList.forEach(v => {
              if (v.speciesType == perUnit) {
                if(v.type == 60){
                num = num + Number((isNull(v.typeExtend) ? 0 :v.typeExtend.length))
                }else if(v.type == 50){
                  num =  num + Number((isNull(v.typeExtend) ? 0 : v.typeExtend[0]))
                }else if(v.type == 20){
                  num = num + 2;
                }else{
                  num = num + 1
                }
              }
            })
          }
          return num
        }
      },
      computeMultiplication(){
        return function(a,b=1){
          return this.$bigNumber(a, '*', isNull(b)? 1 : b)
        }
      },
    },
    created () {
      this.getPhysioIntervalEnum()
    },
    methods: {
      // 获取穴位、部位列表
      getAcupointsList(acupointName) {
        if(isNull(acupointName)){
          this.acupointOptions = []
          return;
        }
        acupointList({ acupointName, speciesType: '' }).then(res => {
          let { code, rows } = res
          if (code == 200) {
            this.acupointOptions = rows;
          }
        })
      },
      //获取理疗执行周期
      async getPhysioIntervalEnum() {
        const res = await getPhysioIntervalEnum()
        if (res.code == 200) {
          this.physioIntervalEnum = res.data && res.data.map(v => {
            v['label'] = v.executeDesc
            v['value'] = v.executeDesc
            return v
          }) || []
        }
      },
      //选择穴位或部位
      selectAcupointName(val, activityIndex, projectIndex) {
        let item = this.actList[activityIndex].items[projectIndex]
        let acupointinfoList = item.physioExtendJson.acupointinfoList || []
        let acupointIndex = acupointinfoList.findIndex(v => {
          return v.acupointId == val
        })
        if (acupointIndex > -1) {
          this.alreadyAdd = `note${activityIndex}${projectIndex}`
          this.acupointName = ''
          setTimeout(() => {
            this.alreadyAdd = '';//是否添加过
          }, 2000)
          return;
        }
        let acupoint = this.acupointOptions.find(v => { return v.acupointId == val })
        if(acupoint.type == 50){
          acupoint.typeExtend = ['1']
        }else if(acupoint.type == 60){
          acupoint.typeExtend = ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4']
        }
        item.physioExtendJson.acupointinfoList.push(acupoint)
        if (item.physioExtendJson.perUnit && item.physioExtendJson.perUnit != acupoint.speciesType) {
          this.speciesTypeTips = `note${activityIndex}${projectIndex}${item.physioExtendJson.acupointinfoList.length - 1}`
          setTimeout(() => {
            this.speciesTypeTips = '';
          }, 2000)
        }
        this.$nextTick(()=>{
          this.$refs[`search${activityIndex}${projectIndex}`][0].blur()
          this.$refs[`search${activityIndex}${projectIndex}`][0].focus()
        })

        this.saveActivity(activityIndex)
        
        this.acupointName = ''
        this.acupointOptions = []
      },
      //改变穴位或部位
      changeAcupoint(val, activityIndex, projectIndex, acupointIndex) {
        let item = this.actList[activityIndex].items[projectIndex]
        let aIndex = item.physioExtendJson.acupointinfoList.findIndex(v => {
          return v.acupointId == val
        })
        if (aIndex > -1) {
          this.alreadyAdd = `note${activityIndex}${projectIndex}${acupointIndex}`
          item.physioExtendJson.acupointinfoList[acupointIndex].acupointName = ''
          this.acupointOptions = []
          setTimeout(() => {
            this.alreadyAdd = '';//是否添加过
            item.physioExtendJson.acupointinfoList[acupointIndex] = this.focusAcupoint
          }, 2000)
          return;
        }
        let acupointObj = this.acupointOptions.find(v => { return v.acupointId == val })
        if(acupointObj.type == 50){
          acupointObj.typeExtend = ['1']
        }else if(acupointObj.type == 60){
          acupointObj.typeExtend = ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4']
        }
        item.physioExtendJson.acupointinfoList[acupointIndex] = acupointObj
        if (item.physioExtendJson.perUnit && item.physioExtendJson.perUnit != acupointObj.speciesType) {
          this.speciesTypeTips = `note${activityIndex}${projectIndex}${acupointIndex}`
          setTimeout(() => {
            this.speciesTypeTips = '';
          }, 2000)
        }
        this.$nextTick(()=>{
          this.$refs[`search${activityIndex}${projectIndex}`][0].blur()
          this.$refs[`search${activityIndex}${projectIndex}`][0].focus()
        })

        this.saveActivity(activityIndex)
        
        this.acupointName = ''
        this.acupointOptions = []
      },
      changeAcupointType(val, activityIndex, projectIndex, acupointIndex) {
        let item = this.actList[activityIndex].items[projectIndex]
        let acupoint = item.physioExtendJson.acupointinfoList[acupointIndex]
        if( acupoint.type != 10 && acupoint.type != 60 && acupoint.type != 50 && val == 10){
          return
        }
        if(acupoint.type == 50){
          acupoint.typeExtend = [`${val}`]
        }else{
          acupoint.type = val
        }
        this.$forceUpdate()
        this.saveActivity(activityIndex)
        this.$refs[`popover${activityIndex}${projectIndex}${acupointIndex}`][0].doClose()
      },
      SiFenChange(val, activityIndex){
        this.$forceUpdate()
        this.saveActivity(activityIndex)
      },
      acupointFocus(obj) {
        this.acupointOptions = []
        this.focusAcupoint = deepClone(obj)
      },
      deleteAcupoint(activityIndex, projectIndex, acupointIndex) {
        let item = this.actList[activityIndex].items[projectIndex]
        item.physioExtendJson.acupointinfoList.splice(acupointIndex, 1)
        this.saveActivity(activityIndex)
      },
      openAcupoint(activityIndex, projectIndex) {
        let list = this.actList[activityIndex].items[projectIndex].physioExtendJson.acupointinfoList || []
        this.chooseList = deepClone(list) 
        this.acupointDialogObj.index = activityIndex
        this.acupointDialogObj.physioIndex = projectIndex
        this.acupointDialogObj.tabIndex = ( !isNull(this.actList[activityIndex].items[projectIndex].physioExtendJson.perUnit) && this.actList[activityIndex].items[projectIndex].physioExtendJson.perUnit) == 20 ? 2 : 0
        this.acupointDialogShow = true
      },
      acupointDialogClose() {
        this.acupointDialogShow = false
      },
      accupointConfirm(obj) {
        let { index, physioIndex, chooseList } = obj
        chooseList.forEach(v=>{
          if(v.type == 50){
            v.typeExtend = isNull(v.typeExtend) ? ['1'] : v.typeExtend
          }else if(v.type == 60){
            v.typeExtend = isNull(v.typeExtend) ? ['1-1','1-2','1-3','1-4','2-1','2-2','2-3','2-4'] : v.typeExtend
          }
        })
        let item = this.actList[index].items[physioIndex]
        item.physioExtendJson.acupointinfoList = chooseList
        this.saveActivity(index)
        this.acupointDialogShow = false
      },
      physioIntervalEnumChange (val, activityIndex, projectIndex) {
        let project = this.actList[activityIndex].items[projectIndex]
        if (['', null, undefined].includes(val)) {
          project.executeCount = null
          project.executeInterval = null
          project.executeDesc = null
          project.physioExtendJson.physioIntervalEnum = null
        } else {
          const physioIntervalEnum = this.physioIntervalEnum.find(v => { return v.executeDesc === val })
          project.executeCount = physioIntervalEnum.executeCount
          project.executeInterval = physioIntervalEnum.executeInterval
          project.executeDesc = physioIntervalEnum.executeDesc
          project.physioExtendJson.physioIntervalEnum = physioIntervalEnum.key
        }

        this.saveActivity(activityIndex)
      },
      physioRemarkInput(project) {
        // 去除换行符
        project.remark = project.remark.replace(/[\n]+/g, '')
      },
      physioRemarkBlur(project) {
        if (project.remark && project.remark.trim() == '') {
          project.remark = null
        }
      },
      async saveActivity(activityIndex) {
        if (this.isDisabled || this.isEdit) {
          return
        }
        const activity = this.actList[activityIndex]

        const res = await postCombSaleSelect({
          deptId: this.deptId,
          orderId: this.orderId,
          actCount: activity.actCount,
          actNumber: activity.actNumber,
          items: activity.items
        })
      },
      removeActivity(activityIndex) {
        this.$confirm('是否确定删除该套餐？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          if (this.isDisabled || this.isEdit) {
            this.actList.splice(activityIndex, 1)
          } else {
            const activity = this.actList[activityIndex]
            const res = await deleteCombSaleSelect({
              orderId: this.orderId,
              actNumber: activity.actNumber
            })
            if (res.code == 200) {
              this.actList.splice(activityIndex, 1)
            }
          }
        }).catch(() => {})
      },
      editActivity (activityIndex) {
        const activity = this.actList[activityIndex]
        this.$refs['comboEdit'].open(activity)
      },
      async submitComboEdit (info) {
        const physioList = info.physios.filter(v => {
          v['drugType'] = 1
          v['itemName'] = v.drugName
          v['spuCommonName'] = v.drugName
          v['itemUnit'] = v.unit
          v['executeCount'] = v.executeCount || null
          v['executeDesc'] = v.executeDesc || null
          v['executeInterval'] = v.executeInterval || null
          v['physioExtendJson'] = v.physioExtendJson || {
            acupointinfoList: [],
            executionMode: v.executionMode,
            onlyNum: v.groupCount,
            perUnit: v.perUnit,
            perUnitCount: v.perUnitCount,
            physioIntervalEnum: null,
            soldNum: v.executionMode === 20 ? v.itemNum * v.groupCount : v.itemNum
          }
          return v.itemNum > 0
        })
        const drugList = info.drugs.filter(v => {
          v['drugType'] = 2
          v['itemName'] = v.drugName
          v['spuCommonName'] = v.drugName
          v['itemUnit'] = v.unit
          v['executeCount'] = null
          v['executeDesc'] = null
          v['executeInterval'] = null
          return v.itemNum > 0
        })

        if (this.isDisabled || this.isEdit) {
          const activity = {
            actNumber: info.number,
            actCseName: info.cseName,
            actCount: info.count,
            totalPrice: Math.round(info.count * info.price * 100) / 100,
            items: [...physioList, ...drugList]
          }
          const activityIndex = this.actList.findIndex(v => { return v.actNumber === info.number })
          if (activityIndex > -1) {
            this.actList.splice(activityIndex, 1, activity)
            this.$message.success('套餐修改成功')
          } else {
            this.$message.error('套餐不存在')
          }
          this.$refs['comboEdit'].close()
        } else {
          const params = {
            deptId: this.deptId,
            orderId: this.orderId,
            actNumber: info.number,
            actCount: info.count,
            items: [...physioList, ...drugList]
          }

          const res = await postCombSaleSelect(params)

          if (res.code === 200) {
            this.$message.success('套餐修改成功')
            this.$refs['comboEdit'].close()
            this.$emit('refreshOrder')
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .activityProject {
    width: 100%;
  }

  .activity {
    box-sizing: border-box;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }

  .activity + .activity {
    margin: 16px 0 0 0;
  }

  .activity.disabled {
    background-color: #F7F8F9;
  }

  .activity.disabled .disabled {
    background-color: #F7F8F9 !important;
    cursor: not-allowed !important;
  }

  .activity.disabled /deep/ .el-input__inner {
    background-color: #F7F8F9 !important;
  }

  .activity.disabled /deep/ .el-textarea__inner {
    background-color: #F7F8F9 !important;
  }

  .header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px;
    width: 100%;
    height: 40px;
  }

  .header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_left_icon {
    width: 20px;
    height: 20px;
  }

  .header_left_title {
    margin: 0 0 0 10px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #000000;
  }
  
  .header_left_description {
    margin: 0 0 0 10px;
    line-height: 20px;
    font-size: 13px;
    color: #667182;
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .header_edit {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    height: 28px;
    font-size: 14px;
    color: #667182;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    cursor: pointer;
    user-select: none;
  }

  .header_delete {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0 0 4px;
    width: 28px;
    height: 28px;
    font-size: 18px;
    color: #667182;
    cursor: pointer;
    user-select: none;
  }

  .project_list {
    width: 100%;
  }

  .project_item {
    width: 100%;
    border-top: 1px solid #E0E0E0;
  }

  .project_header {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
  }

  .project_header_index {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 100%;
    font-size: 14px;
    color: #000000;
  }

  .project_header_label {
    flex-grow: 1;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 12px;
    height: 100%;
    border-left: 1px dashed #E0E0E0;
  }

  .project_header_label_name {
    line-height: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .project_header_label_type {
    margin: 0 0 0 4px;
    line-height: 20px;
    font-size: 14px;
    color: #667182;
  }

  .project_header_count {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 100%;
    font-size: 14px;
    color: #667182;
    border-left: 1px dashed #E0E0E0;
  }

  .project_header_remark {
    flex-shrink: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    width: 120px;
    height: 100%;
    border-left: 1px dashed #E0E0E0;
  }

  .project_header_remark_input {
    width: 100%;
  }

  .project_header_remark_input /deep/ .el-input__inner {
    padding: 0;
    border: none;
  }

  .project_point_section {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 8px 12px;
    width: 100%;
    border-top: 1px dashed #E0E0E0;
  }

  .acupoint-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, 138px);
    gap: 8px;
    width: 100%;
  }

  .acupoint-item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 32px;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;   
  }

  .acupoint-item /deep/.el-input__inner {
    padding: 0 8px 0 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .acupoint-item /deep/.el-input__inner:focus {
    border: 1px solid #409EFF;
  }

  .acupoint-item-tips {
    position: absolute;
    z-index: 2;
    top: -32px;
    left: 0;
    padding: 8px 10px;
    font-size: 14px;
    color: #FFFFFF;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 2px;
    white-space: nowrap;
  }

  .acupoint-item-tips2 {
    box-sizing: border-box;
    position: absolute;
    z-index: 99;
    top: 33px;
    display: none;
    padding: 8px 12px;
    font-size: 12px;
    color: #303133;
    background-color: #FFFDE9;
    border-radius: 4px;
    filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.15));
  }

  .acupoint-item-left {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 100%;
  }

  .acupoint-item-icon {
    position: absolute;
    z-index: 2;
    top: 4px;
    right: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  .acupoint-icon {
    width: 18px;
    height: 18px;
  }

  .el-icon-close {
    position: absolute;
    top: 7px;
    right: 4px;
    display: none;
    font-size: 16px;
    color: #A4AFBA;
    background-color: #EBECED;
    border-radius: 50%;
    cursor: pointer;
  }

  .acupoint-item:hover .acupoint-item-tips2 {
    display: block !important;
  }

  .acupoint-item:hover .acupoint-item-icon {
    background: #E8F4FF;
  }

  .acupoint-item:hover .el-icon-close {
    display: block;
  }

  .acupoint-list /deep/ .el-input__inner {
    height: 30px;
    border: 1px solid transparent;
  }

  .acupoint-list /deep/ .el-input__inner:hover {
    border: 1px solid #409EFF;
    border-radius: 0px 2px 2px 0px;
  }

  .acupoint-list /deep/ .is-disabled {
    color: #000;
    background: #F7F8F9;
  }

  .acupoint-list .el-button {
    border: none;
    border-right: 1px solid #E0E0E0;
  }

  .acupoint-list .el-button:active {
    color: #000000;
    background-color: #FFFFFF;
    border: 1px solid #409EFF;
    border-radius: 2px 0px 0px 2px;
  }

  .acupoint-list .el-button:hover {
    color: #000000;
    background: #FFFFFF;
  }

  .acupoint-list .el-button:focus {
    color: #000000;
    background-color: #FFFFFF;
  }

  .acupoint-total {
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding-bottom: 8px;
    font-size: 14px;
    color: #29C01B;
  }

  .project_options {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 12px;
    width: 100%;
    border-top: 1px dashed #E0E0E0;
  }

  .project_options_item {
    line-height: 33px;
    font-size: 14px;
    color: #667182;
  }

  .project_options_item + .project_options_item {
    margin: 0 0 0 12px;
  }

  .project_options_select {
    margin: 0 0 0 12px;
    border-bottom: 1px solid #E0E0E0;
  }

  .project_options_tips {
    margin: 0 0 0 12px;
    line-height: 33px;
    font-size: 14px;
    color: #000000;
  }

  .project_remark {
    box-sizing: border-box;
    padding: 8px 12px;
    width: 100%;
    border-top: 1px dashed #E0E0E0;
  }

  .physio_product_remark {
    width: 100%;
  }

  .physio_product_remark /deep/ .el-textarea__inner {
    padding: 0;
    line-height: 32px;
    font-size: 14px;
    border: none;
  }

</style>